import { render, staticRenderFns } from "./policytwo.vue?vue&type=template&id=53c6bbdd&scoped=true&"
import script from "./policytwo.vue?vue&type=script&lang=js&"
export * from "./policytwo.vue?vue&type=script&lang=js&"
import style0 from "./policytwo.vue?vue&type=style&index=0&id=53c6bbdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c6bbdd",
  null
  
)

export default component.exports